import React from 'react'

function Footer() {
  return (
      <div style={{
          background: 'black',
          color: 'white',
          padding: '12px',
          textAlign: 'center',
          fontFamily: 'sans-serif',
          fontSize:'10px'
      }
      }
      >
        <h1 style={{margin:'0px'}}>Thanks for visiting my page hope you are find correct information</h1>
    </div>
  )
}

export default Footer
